import { getFirebase } from 'react-redux-firebase';
import { createSelector } from 'reselect';
import { get as _get, merge as _merge } from 'lodash';

import {
    selectFirestore,
    selectListPendingFactory,
    selectDetailPendingFactory,
    selectItemPendingFactory,
} from 'services/selectors';

import config from 'config/index';
import { utils as uploaderUtils } from 'modules/uploader';

import { defaultValues } from './config';
import { getNewsDetailKey } from './utils';

const selectNewsState = state => state.news;

const selectPending = createSelector(selectNewsState, news => news.pending);

export const selectListPending = selectListPendingFactory(selectPending);

export const selectDetailPending = selectDetailPendingFactory(selectPending);

export const selectItemPending = selectItemPendingFactory(selectPending);

export const selectNews = createSelector(selectFirestore, firestore => {
    const Timestamp = getFirebase().firestore.Timestamp;

    const news = _get(firestore.ordered, 'news', []).map(news => ({
        ..._merge({}, defaultValues, news),
        time: new Timestamp(news.time.seconds, news.time.nanoseconds),
        delayed: false,
    }));

    const delayedNews = _get(firestore.ordered, 'newsDelayed', []).map(news => ({
        ..._merge({}, defaultValues, news),
        time: new Timestamp(news.time.seconds, news.time.nanoseconds),
        delayed: true,
    }));

    return [...news, ...delayedNews].sort((a, b) => b.time.toDate() - a.time.toDate());
});

const selectNewsUpdateProps = (_, { id, delayed }) => ({
    id,
    delayed,
});

export const selectNewsForUpdate = createSelector(
    [selectFirestore, selectNewsUpdateProps],
    (firestore, { id, delayed }) => {
        const Timestamp = getFirebase().firestore.Timestamp;
        const collection = delayed ? config.collections.newsDelayed : config.collections.news;

        return config.app.languages.reduce(
            (data, lang) => {
                const news = _merge({}, defaultValues, _get(firestore.data, getNewsDetailKey(collection, id, lang)));
                data[lang] = {
                    title: news.title,
                    body: news.body,
                };

                if (lang === config.app.defaultLanguage) {
                    data.time = news.time
                        ? new Timestamp(news.time.seconds, news.time.nanoseconds).toDate()
                        : news.time;
                    data.tags = news.tags;
                    data.delayed = delayed;
                    data.images = uploaderUtils.mapImagesToFiles(news.images || []);
                }
                return data;
            },
            { id },
        );
    },
);
